module.exports = __webpack_public_path__ + "static/media/rage-of-the-sea.0b6c0836.jpg";